<template>
  <div id="article" class="d-flex flex-column align-items-stretch h-100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "ArticleView",
  data() {
    return {};
  },
  computed: {
    articleId() {
      return this.$route.params.articleId;
    },
    articleStatus() {
      return (
        this.$route.params.articleStatus ||
        this.$store.state.currentArticleStatus
      );
    },
    articleType() {
      return (
        this.$route.params.articleType || this.$store.state.currentArticleType
      );
    }
  }
};
</script>

<style scoped></style>
